import { createStore } from 'vuex'

export default createStore({
  state: {
    spaceMap: new Map()
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
